<template>
  <div>
    <object-value-list textList v-model="value" @new="edit('')" @remove="remove($event.index)" @edit="edit($event.item,$event.index)">
      <template slot="dialog-form" slot-scope="context">
        <report-param-form ref="form" v-model="context.item" />
      </template>
    </object-value-list>
    <dialog-d
      ref="dialogRef"
      :title="$tc('entities.report.props.params',1)"
      @confirm="confirm(false,$refs.form.validate())"
      @cancel="cancel">
      <report-param-form ref="form" v-model="itemSelected" />
    </dialog-d>
  </div>
</template>

<script>
import objectValueListMixin from "@/mixins/objectPageLists/objectValueListMixing";
import reportParamForm from "./reportParamForm";
export default {
  name: "report-params-tab",
  mixins: [objectValueListMixin],
  components: { reportParamForm },
  props: ["value"],
  data() {
    return {
      teste: ""
    };
  },
  methods: {
    getModelDefault() {
      return "";
    }
  }
};
</script>